import React, { useEffect } from "react";
import Pagination from "@mui/material/Pagination";
import TablePagination from "@mui/material/TablePagination";
import "./Pagination.css";

interface Props {
  className?: string;
  page?: number;
  setPage?: (value: number) => void;
  pageSize?: number;
  setPageSize?: (value: number) => void;
  totalFiltered?: number;
}

const CustomPagination = (props: Props) => {
  const {
    page = 0,
    setPage,
    pageSize = 10,
    setPageSize,
    totalFiltered = 0,
  } = props;

  const safeTotal = Math.max(totalFiltered, 0);
  const safePageSize = Math.max(pageSize, 1);

  const calculatedPages = Math.ceil(
    safeTotal / safePageSize
  );

  // MUI Pagination needs at least one page.
  const totalPages = Math.max(calculatedPages, 1);
  const lastPage = Math.max(calculatedPages - 1, 0);

  useEffect(() => {
    if (page > lastPage) {
      setPage?.(lastPage);
    }
  }, [page, lastPage, setPage]);

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    newPage: number
  ) => {
    setPage?.(newPage - 1);
  };

  const handleChangeOffset = (
    event: unknown,
    newPage: number
  ) => {
    setPage?.(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newPageSize = parseInt(event.target.value, 10);
    setPageSize?.(newPageSize);
  };

  return (
    <div className="pagination-container">
      <div className="pagination-left">
        <TablePagination
          component="div"
          rowsPerPageOptions={[10, 20, 50, 100]}
          rowsPerPage={safePageSize}
          count={safeTotal}
          page={Math.min(page, lastPage)}
          onPageChange={handleChangeOffset}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Rows"
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} of ${count}`
          }
          ActionsComponent={() => null}
        />
      </div>

      <div className="pagination-center">
        <Pagination
          variant="outlined"
          shape="rounded"
          color="primary"
          count={totalPages}
          page={Math.min(page + 1, totalPages)}
          onChange={handleChangePage}
          disabled={safeTotal === 0}
        />
      </div>

      <div className="pagination-right">
        Total: {safeTotal}
      </div>
    </div>
  );
};

export default CustomPagination;